import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { ISignersFormData } from './buildInitialSignersFormData';
import { NoSignersView } from './NoSignersView';
import { AddContactForm } from '../../shared/AddContactForm';
import { SignerAdditionSection } from './SignerAdditionSection';
import { FormTypes } from './SignersForm';
import { eCreateSigningAppointmentFormDataOwnerTypes } from '../../../../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';

const newSignerTitle = 'Add New Signing Party';
const currentSignerTitle = 'Select Existing Signing Party';
export const AddSignerRows: React.FC<{
  typesIndices: FormTypes[];
  handleOnTrashIconClick: (index: number) => void;
  remove: (index: number) => any;
  ownerType: eCreateSigningAppointmentFormDataOwnerTypes;
  replace: (index: number, value: any) => void;
  emailRequired: boolean;
}> = ({ typesIndices, remove, handleOnTrashIconClick, ownerType, replace, emailRequired }) => {
  const { values } = useFormikContext<ISignersFormData>();

  const checkEmailRequirement = useMemo(() => {
    if (!!values.signers?.some((signer) => !!signer.email)) {
      return false;
    }
    return emailRequired;
  }, [emailRequired, values.signers]);

  // signers is undefined or length === 0
  if (!values.signers?.length) return <NoSignersView />;

  return (
    <>
      {values.signers.map((signer, index) => {
        const formType = typesIndices[index];
        const isSelectCurrent = formType === FormTypes.Current;
        return (
          <AddContactForm
            key={`${signer.personId ?? index}`}
            isSigner
            signerIndex={index}
            title={isSelectCurrent ? currentSignerTitle : newSignerTitle}
            signer={signer}
            showExistingContactForm={isSelectCurrent}
            existingContactNode={
              <SignerAdditionSection
                key={`${signer.personId ?? index}`}
                index={index}
                ownerType={ownerType}
                replace={replace}
              />
            }
            onTrashIconClick={() => {
              remove(index);
              handleOnTrashIconClick(index);
            }}
            emailRequired={checkEmailRequirement}
          />
        );
      })}
    </>
  );
};
